import React, {useEffect, useRef} from "react";
import style from './terms.module.css';
import {useNavigate} from "react-router-dom";

const Terms = () => {
  const navigate = useNavigate();
  const timerFadeIn = useRef(null);
  const termsRef = useRef(null);


  useEffect(() => {
    window.scrollTo({top: 0, behavior: 'smooth'});

    if (termsRef.current) {
      termsRef.current.classList.add(style.termsFadeIn);
    }

    timerFadeIn.current = setTimeout(() => {
      termsRef.current.classList.remove(style.termsFadeIn);
    }, 350);

    return () => {
      clearTimeout(timerFadeIn.current)
    }
  }, []);


  return (
    <div ref={termsRef}
         className={style.container}>
      <h1>TERMS AND CONDITIONS</h1>
      <h2>1. Access</h2>
      <p>1.1. By accessing and/or using this site and/or registering Services you confirm that you are at least eighteen
        years old. If you are not the person responsible for paying the mobile phone or internet bill or you are under
        eighteen years of age, please obtain
        the permission of the bill payer, parents, guardian and/or employers before registering and/ or participating in
        the Services.
      </p>
      <p>1.2. By registering and/or participating in the Services, you (1) acknowledge and confirm that, where required,
        you have obtained the necessary permission, consent or approval from the bill payer, parents, guardian or
        employer and (2) accept that you have been offered the opportunity to read and accept the T&amp;C (including the
        terms from your mobile phone operator that apply) before registering for the Services. If you do not agree; do
        not register or use the Services.
      </p>
      <p>1.3. When you register for and/or use the Service you acknowledge and confirm that you
        have accepted these Terms and that you comply with the terms that apply in your situation, as specified above.
        You
        agree that each person who requests such Services is your agent with full authority to act on your behalf with
        respect
        to such Services. Unless explicitly stated otherwise, any new or additional features that augment or enhance the
        current Services, including the release of new Services, shall be subject to the T&amp;C.
      </p>
      <p>1.4. By accessing and/or using this site, you have read and understand these conditions, and accept that you
        are legally bound by
        these T&amp;C. These T&amp;C will apply to all services provided by Content Provider unless stated otherwise.
      </p>
      <h2>2. Terms of Use</h2>
      <p>2.1. The content provider provides the Subscriber on the subscription content in the manner prescribed by these
        Rules.
      </p>
      <p>2.2. By accepting these rules, you confirm your legal capacity to carry out an Order in accordance with the
        requirements of the current legislation of Spain.
      </p>
      <p>2.3. A subscriber who wants to receive a Subscription to the Content must have the equipment necessary for
        placing an Order, receiving the Content Service and Subscribing to the Content.</p>
      <p>2.4. The Subscriber confirms he has read these T&amp;C, and confirms the fact of fulfillment of all the
        requirements set forth by the T&amp;C for the Subscriber.</p>
      <p>2.5. The content provider is fully responsible for the compliance of the Content with the current regulations
        set by Mobile Network Operator.
      </p>
      <h2>3. Unsubscription order</h2>
      <p>3.1. The Subscriber can unsubscribe from the Subscription to the Content in case he is not willing to use it
        anymore.</p>
      <p>3.2. The Subscriber should conduct Unsubscription from the Service on his own by sending Key Word via Short
        Code.</p>
      <h2>4. Limitation of Content Provider Liability</h2>
      <p>4.1. Content Provider shall not be liable for:</p>
      <li className={style.ul}>a. transmission failure;</li>
      <li className={style.ul}>b. break the connection;</li>
      <li className={style.ul}>c. deleting message content or Subscriber data;</li>
      <li className={style.ul}>d. inaccessibility to the online platform;</li>
      <li className={style.ul}>e. delays in data transmission;</li>
      <li className={style.ul}>f. interruptions or other interruptions in the communication line;</li>
      <li className={style.ul}>g. theft of notes;</li>
      <li className={style.ul}>h. destruction of any data by a third party;</li>
      <li className={style.ul}>i. unauthorized access to data;</li>
      <li className={style.ul}>j. data manipulation;</li>
      <li className={style.ul}>k. misuse of data.</li>
      <p> 4.2. In addition, Content Provider is not responsible for the content of messages, since these messages cannot
        be checked in terms of content.
        The content of the message is the responsibility of the author. Liability exclusion or limitation of liability
        excludes losses consisting in damage to health or life-threatening, or which may be inferred from a substantial
        breach of obligations by Content Provider or its legal representative or agent. The Content Provider liability
        is
        limited depending on the alleged damage. Any Content Provider liability in accordance with the legislation on
        the
        manufacturer’s liability for damage caused by a defect in the product remains unchanged.</p>
      <h2>5. Limitations</h2>
      <p>5.1. In case the Subscribers Equipment does not support the format required to play, launch or view the
        Content, the Subscription to the Content cannot be guaranteed.</p>
      <p>5.2. The Subscriber is entitled to use the
        Content only for personal purposes and not allowed to distribute it by selling or otherwise alienating the
        Content
        to third parties.</p>
      <p>5.3. By accepting these Terms, the Subscriber agrees with the above limitations when providing a Subscription
        to the Content.</p>
      <p>5.4. In case the Subscriber does not want to use the Subscription to the Content with the limitations specified
        in these T&amp;C, the Subscriber has the right to disconnect the Subscription to the Content in the order
        specified in section 4 of these T&amp;C.</p>
      <h2>6. Subscriber`s Responsibilities</h2>
      <p>6.1. The Content Provider is required to store access data and mobile phones in a safe place and not transfer
        them to third parties. </p>
      <p>6.2. In case of loss of access data and / or mobile phone, the Subscriber is obliged to
        immediately inform Content Provider about this loss and immediately block the mobile phone from the relevant
        mobile
        operator. Until the loss is reported to the Content Provider the Subscriber is responsible for the costs
        associated
        with the use of SMS chat.</p>
      <p>6.3.. The Subscriber undertakes to exclude Content Provider from claims, claims and
        liability to third parties, which are alleged to be a violation of the rights of third parties by the
        participant or
        other content of the message that is contrary to the law or contract. This also applies to law enforcement
        expenses
        (legal and legal expenses).</p>
      <h2>7. Intellectual Property Rights</h2>
      <p>7.1. Except as otherwise set forth herein, all right, title and interest in and to any intellectual property,
        proprietary rights or other rights related to intangible property which are used, developed, comprising,
        embodied in, or practiced in connection with any of the
        Services (‘Content Providers Intellectual Property Rights’) are owned by Content Provider or its licensors and
        you
        agree to make no claim of interest in or ownership of any such Content Providers Intellectual Property
        Rights. </p>
      <p>7.2. Content Provider hereby grants, and you hereby accept, a personal, limited, non-transferable,
        non-exclusive, revocable and non-assignable license and permission to download and use the Services on a
        designated compatible mobile device solely for your own personal, non-commercial use. </p>
      <p>7.3. You further acknowledge and agree that
        you may not amend, rent, rent out, lend, lease, borrow, loan, sell, distribute, create or generate the Services
        and/or the Content Provider Intellectual Property rights except in the event that Content Provider has given you
        explicit written permission to do so. </p>
      <p>7.4. You acknowledge that no title to the Content Provider
        Intellectual
        Property Rights is transferred to you, and that you do not obtain any rights, express or implied, in the
        Services,
        other than the rights expressly granted in these T&amp;C. </p>
      <p>7.5. You acknowledge that all marks that appear
        throughout the Services belong to Content Provider, or the respective owners of such marks, and are protected by
        domestic and international trademark and copyright laws. </p>
      <p>7.6. Any use of any of the marks appearing
        throughout the Services without the express written consent of Content Provider or the owner of the mark, as
        appropriate, is strictly prohibited.</p>
      <p>7.7. The Services may be downloaded only once and may not be
        transferred,
        sold, distributed, displayed, performed, copied, modified or used in any way, in whole or in part, other than as
        contemplated by these T&amp;C.</p>
      <p>7.8. You guarantee that you will only use the interface provided by Content
        Provider in order to access the Services. </p>
      <p>7.9. You agree that the right holders, which license their
        musical
        and other content items to Content Provider for use in the Services, are comprehended in this sense by the scope
        of
        protection of this agreement, and that they are themselves authorized to enforce the provisions of this
        agreement,
        which relate directly to their content. </p>
      <p>7.10. You know that the use of musical pieces is subject to the
        terms
        of use as set out below. You may not allow a third party to copy, modify, reproduce, transfer, distribute or use
        in
        any other manner pieces of music, which you use or receive, outside the limits narrowly allowed by copyright.
        You
        oblige yourself to immediately inform Company of any such non-authorized use. All rights, which are not
        expressly
        granted to you by this T&amp;C, are reserved by Content Provider and/or its licensors.</p>
      <h2>8. Other
        Conditions</h2>
      <p>8.1. Unsubscription from the Content Service entails termination of the Subscription to the
        Content.</p>
      <p>8.2. In case the Subscriber disconnects from the Content Service, the Subscription to the Content
        can
        be provided only after the Subscriber will subscribe again.</p>
      <p>8.3. The content provider has received all
        necessary permissions to use the content.</p>
      <div className="wp-block-buttons is-content-justification-center">
        <div className={style.wpBlockButton}
             onClick={() => navigate(-1)}>
          Go Back
        </div>
      </div>
      <br/>
    </div>
  )
}

export default Terms;